export interface ZoneMenuProps {
  countryCode: string
  currentLabelTitle: string
  currentSpaceTitle?: string
}

export interface ZoneMenuWrapperProps {
  children: JSX.Element
  currentLabelTitle?: string
  countryCode: string
  currentSpace?: {
    id: string
    name?: string | null
  }
  currentSpaceTitle?: string
}
export interface ZoneMenuItemProps {
  type: ZoneMenuItemType
  onSelect(id: string): void
  value?: string
  options: {
    label: string,
    value: string,
    subtitle?: string,
    tooltip?: string
  }[]
}

export enum ZoneMenuItemType {
  ZONE = 'ZONE',
  COUNTRY = 'CHART COUNTRY',
  SPACES = 'SPACES'
}
